import { SortOption } from '../../../core';
import { OptionsEditorControl } from '../OptionsEditorLayout';
import { SettingsAutocomplete } from '../SettingsAutocomplete';

export const SORT_OPTIONS: Array<{ id: SortOption; label: string; description?: string }> = [
  { id: 'default', label: 'Default', description: 'Original data order' },
  { id: 'asc', label: 'Ascending (value)', description: 'Lowest to highest value' },
  { id: 'desc', label: 'Descending (value)', description: 'Highest to lowest value' },
  { id: 'series-name-asc', label: 'Ascending (A→Z)', description: 'Series name from A to Z' },
  { id: 'series-name-desc', label: 'Descending (Z→A)', description: 'Series name from Z to A' },
];

export interface SortSelectorProps<T> {
  onChange: (sort?: T) => void;
  value?: T;
  options: Array<{ id: T; label: string; description?: string }>;
  disabled?: boolean;
  width?: number;
  id?: string;
}

export function SortSelector<T extends string>(props: SortSelectorProps<T>) {
  return <OptionsEditorControl label="Sort" control={<SortAutocomplete {...props} />} />;
}

export function SortAutocomplete<T extends string>({
  id,
  value,
  onChange,
  disabled,
  width,
  options,
}: SortSelectorProps<T>) {
  const handleSortChange = (_: unknown, { id }: { id: T }) => {
    onChange(id === 'default' ? undefined : id);
  };

  return (
    <SettingsAutocomplete
      id={id}
      value={options.find((o) => o.id === (value === undefined ? 'default' : value))}
      options={options}
      getOptionLabel={(o) => o.label}
      onChange={handleSortChange}
      disableClearable
      disabled={disabled}
      sx={{
        width: width ? `${width}px` : undefined,
      }}
    />
  );
}
